var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v("\n    $"+_vm._s(_vm.price_per_year)+" "),(_vm.show_notice)?_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"b-tip",attrs:{"title":"Based on current standard price"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }